import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity LogHistories


export interface LogHistory {
    id: ID;

    
    logId: ID;

    
    action: string;

    
    contextHistory?: string;

    
    updatedAt: Date;

    
    internalKey: string;

    
    timberKey: string;

    
    volume: number;

    
    storageId: ID;

    
    locationId: ID;

    
    cuttingId: ID;

    
    shipmentId?: ID;

    
    state?: ShipmentState;

    
    length: number;

    
    diameter: number;

    
    timberTypeId: ID;

    
    classId: ID;

    
    thicknessClassId: ID;

    
    linked: boolean;

    
    barkThickness?: number;

    
    commited: boolean;

    
    scopeGroupId: ID;

    
    siteId?: string;

    
    localCreatedAt: Date;

    }

export interface FilterByContextRequest {
    list: ListRequest,
    filter: {
        
            cuttingId?: ID,
        
    
    

            action?: string,
        
    
    

            contextHistory?: string,
        
    
    contextHistoryInclude: boolean,



        logIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateLogHistory {
    
    logId: ID;

    
    action: string;

    
    contextHistory?: string;

    
    
    
    
    
    
    
    
    
    state?: ShipmentState;

    
    
    
    
    
    
    
    
    
    
    
    }



export interface PresentationLogHistoryRequest {
    list: ListRequest,
    filter: {
        logId: ID,
        logIdOr: boolean,
        action: string,
        actionOr: boolean,
        logIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryLogHistory {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: LogHistory): PrimaryLogHistory | undefined {
        return entity ? new PrimaryLogHistory(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryLogHistory {
        return new PrimaryLogHistory(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryLogHistory {
        let vals = path?.split('/');
        return new PrimaryLogHistory(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryLogHistory[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: LogHistory): string {
    let fields = entity ? [
    entity.logId,
            entity.action,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


